import { Phone, CalendarCheck } from "lucide-react";
import { CONTACT } from "../../data/content";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function MobileCta() {
  return (
    <div
      data-testid="mobile-bottom-cta"
      className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t border-black/5 bg-white/90 backdrop-blur-lg lg:hidden"
    >
      <a
        href={CONTACT.phoneHref}
        data-testid="mobile-bottom-call"
        className="flex items-center justify-center gap-2 border-r border-black/5 py-4 font-semibold text-brand-primary"
      >
        <Phone size={18} />
        Hívás
      </a>
      <button
        data-testid="mobile-bottom-survey"
        onClick={() => scrollTo("#kapcsolat")}
        className="flex items-center justify-center gap-2 bg-brand-accent py-4 font-semibold text-white"
      >
        <CalendarCheck size={18} />
        Felmérést kérek
      </button>
    </div>
  );
}
